import { Container, type ContainerProps } from '@chakra-ui/react'
import React from 'react'

export type ContentSectionProps = {
	children: React.ReactNode
} & ContainerProps

const ContentSection = ({ children, ...containerProps }: ContentSectionProps) => {
	return (
		<Container gap={16} maxW={'7xl'} p={0} {...containerProps}>
			{children}
		</Container>
	)
}

export default ContentSection